import { appendAPExamTemplate } from '@/functions/idp'
import RIC from './RIC_3'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
